/**
 * Activated Modules Store
 *
 * Tracks which modules are activated/installed in the current workspace.
 * Persisted to localStorage so it survives page reloads.
 *
 * A module appears in the ActivityBar and Toolbox only when:
 *   1. The user owns it (hasAccess from auth API), AND
 *   2. It's activated locally (this store) — either user clicked
 *      "Activate" (pure React modules like Oracle) or it's detected
 *      as installed (UE plugin modules like CC via bridge).
 *
 * Location: lib/stores/ (shared global state per project convention)
 */

import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

/** Set of module IDs that are activated/installed in this workspace */
export const activatedModulesAtom = atomWithStorage<string[]>(
  'gdb-activated-modules',
  []
)

/** Derived atom: quick lookup set */
export const activatedModulesSetAtom = atom((get) => {
  return new Set(get(activatedModulesAtom))
})
